import { render, staticRenderFns } from "./selfpick.vue?vue&type=template&id=5a40b813&scoped=true&"
import script from "./selfpick.vue?vue&type=script&lang=js&"
export * from "./selfpick.vue?vue&type=script&lang=js&"
import style0 from "./selfpick.vue?vue&type=style&index=0&id=5a40b813&scoped=true&lang=css&"
import style1 from "./selfpick.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a40b813",
  null
  
)

export default component.exports